/**
 * Calculates the amount receivable when the cost to repair the vehicle exceeds its actual cash value (ACV).
 * @param insuredValue The value that is insured.
 * @param totalLossPercentage The percentage of the insured value that is considered a total loss.
 * @returns Total gross amount.
 * @example
 * ```ts
 * const insuredValue = 400;
 * const totalLossPercentage = 70;
 * const total = totalLossAmountReceivable(insuredValue, totalLossPercentage);
 * console.log(total); // Output: 280
 * ```
 */
export function totalLossAmountReceivable(
	insuredValue: number,
	totalLossPercentage: number,
): number {
	// Check
	insuredValue = isNaN(insuredValue) ? 0 : insuredValue;
	totalLossPercentage = isNaN(totalLossPercentage) ? 0 : totalLossPercentage;

	return insuredValue * (totalLossPercentage / 100);
}
